import ReactGA from "react-ga";
import { configureEnvironment } from "./../../config/env";

export const inicializarAnalytics = () => {
  if (configureEnvironment().REACT_APP_CODIGO_GOOGLE_ANALYTICS) {
    ReactGA.initialize(
      configureEnvironment().REACT_APP_CODIGO_GOOGLE_ANALYTICS,
      {
        titleCase: false,
      }
    );
  }
};

export const cadastrarEvento = (evento, label) => {
  if (configureEnvironment().REACT_APP_CODIGO_GOOGLE_ANALYTICS) {
    ReactGA.event({
      category: "Onboarding",
      action: evento,
      label: String(label),
      value: 1,
    });
  }
};
